module.exports = __webpack_public_path__ + "static/media/home-mobile-2026-eng.9aeeeba6.png";